import styles from '../ModalActionsButtons/modalActionsButtons.module.scss'
import ModalFooter from '../ModalFooter/ModalFooter'

interface Props {
  handleCancel?: () => void
  handleClose?: () => void
}

const RFQModalFooter = ({ handleCancel, handleClose }: Props) => {
  return (
    <ModalFooter
      dataTestId="rfq-modal-footer"
      buttonComponent={
        <div className={styles.buttonsComponents}>
          {!!handleCancel && (
            <button
              data-testid="rfq-modal-footer-cancel"
              onClick={handleCancel}
            >
              Cancel RFQ
            </button>
          )}
          <button data-testid="rfq-modal-footer-close" onClick={handleClose}>
            Close Window
          </button>
        </div>
      }
    />
  )
}

export default RFQModalFooter
